export type NavbarItems = {
  name: string;
  url: string;
};
export const jetCashNavItems: NavbarItems[] = [
  {
    name: 'nav.jet.cash',
    url: '/ecash',
  },
  {
    name: 'nav.jet.cash.history',
    url: '/ecashhistory',
  },
];
